<app-header></app-header>
<div class="body-wrapper">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>

<div class="cloud_form" style="display: none;">
<img src="/newpion/static/pionfront/assets/img/cloud.png">
<p>
    Задать вопрос специалисту
</p>
</div>